import { Link } from "react-router-dom"

export default function Contact() {
	return (
		<>
			<section
				className="contact-section fix  bg-cover" id="contact"
			// style={{ backgroundImage: 'url("assets/img/contact-bg.jpg")' }}
			>
				<div className="contact-image float-bob-x">
					{/* <img src="assets/img/contact-img-shape.png" alt="img" /> */}
				</div>
				{/* <div className="container"> */}
				<div className="contact-wrapper">
					<div className="row g-4 align-items-center">
						<div className="">
							<div className="contact-items">
								<h3 className="wow fadeInUp" data-wow-delay=".2s">
                                     Contact Us?
								</h3>
								<form action="https://api.web3forms.com/submit" method="POST">
								<input type="hidden" name="access_key" value="d8fd440b-b7b0-4931-8682-3c4eb67d846d"/>
									<div className="row g-4">
										<div
											className="col-lg-6 col-md-6 wow fadeInUp"
											data-wow-delay=".2s"
										>
											<div className="form-clt">
												<input
													type="text"
													name="name"
													id="name"
													placeholder="Name"
												/>
											</div>
										</div>
										<div
											className="col-lg-6 col-md-6 wow fadeInUp"
											data-wow-delay=".2s"
										>
											<div className="form-clt">
												<input
													type="text"
													name="number"
													id="number"
													placeholder="Phone"
												/>
											</div>

										</div>
										<div
											className="col-lg-12 wow fadeInUp"
											data-wow-delay=".4s"
										>
											<div className="form-clt">
												<input
													type="text"
													name="email"
													id="email"
													placeholder="email"
												/>
											</div>
										</div>
										
									
									{/* <div
												className="col-lg-6 col-md-6 wow fadeInUp"
												data-wow-delay=".4s"
											>
												<div className="form-clt">
													<input
														type="text"
														name="subject"
														id="subject"
														placeholder="Subject"
													/>
												</div>
											</div> */}
									<div
										className="col-lg-12 wow fadeInUp"
										data-wow-delay=".2s"
									>
										<div className="form-clt">
											<input
												name="message"
												id="message"
												placeholder="write message . ."
												defaultValue={""}
											/>
										</div>
									</div>
									<input type="hidden" name="redirect" value="https://web3forms.com/success"></input>
									<div
										className="col-lg-12 wow fadeInUp d-flex justify-content-center"
										data-wow-delay=".4s"
									>
										<button type="submit" className="theme-btn">
											Send message <i className="fas fa-long-arrow-right" />
										</button>
									</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div >
			{/* </div> */ }
			</section >
		</>
	)
}
